define('modules/form_editor/views/editor_custom_terms',['require','exports','module','base/view','lib/util','../behaviours/has_uploader','ldsh!../templates/editor_custom_terms'],function(require,exports,module){
  "use strict";

  var BaseView = require("base/view"),
      util = require("lib/util"),
      uploaderBehaviour = require("../behaviours/has_uploader");

  var CustomTermsEditorView = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_terms"),
    events: {
      "change textarea": "updateModel",
      "click .js-help": "triggerTooltip"
    },
    initialize: function(options){
      this.options = options.options;
      if(!this.options.pages_id){
        throw new Error("Need pageId to upload terms");
      }
      if(!this.options.variants_id){
        this.options.variants_id = "main";
      }
    },
    triggerTooltip: function(e){
      this.$(".js-tooltip").toggleClass("in");
    },
    updateModel: function(e){
      e.preventDefault();
      this.model.set("termsText", this.$(".js-text").val());
    },
    onRender: function(){
      this.$el.i18n();
      this._setupUploader();
    }
  });

  module.exports = CustomTermsEditorView;

  util.mixin(module.exports, uploaderBehaviour);
});

